<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col">
          <div class="avatar">
            <img src="/static/images/people/alex.jpg">
          </div>
          <hr class="space space-sm">
          <h1 class="title">Alex Berezovskiy</h1>
          <p>
            Creative Technologist. Founder. Resolute Partner.
          </p>
          <p>
            <a href="mailto:alex@resolute.partners">alex@resolute.partners</a>
          </p>
          <hr class="space space-sm">
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col">

          <h1 class="title">Nice to meet you!</h1>

          <p>Alex is the founder of <a href="https://mymo.app" target="_blank"><strong>mymo</strong></a> - a mindfulness and wellbeing platform dedicated to making it easier to stay sane in our fast-paced world. With its automatic self-journalling features, <strong>mymo</strong> creates a truly captivating story of its owner, so the most important things in life are never out of sight.</p>

          <p>Prior to <strong>Mymo</strong>, Alex spent several years running an innovation studio in London working with FTSE 100 companies and startups from seed to series C. He experienced first-hand the difficulties innovators face when bringing their products to life.</p>

          <p>As a Resolute partner, Alex occasionally gets involved in side projects, helping well-funded startups and established companies to bring new products to life. He's especially passionate about great user experiences, turning difficult and complex solutions into intuitive interfaces and products.</p>

          <!-- <p>Alex is the founder of <a href="https://wonder.store" target="_blank">Wonder</a> - an online marketplace where customers can discover the latest inventions and rent them - to try in the comfort of their home or office. In turn, inventors can add products to the platform to gain exposure, find early adopters and their audience. Wonder delivers a variety of products from robots and drones to appliances, vehicles, sporting equipment, to space launch kits and brain-sensing headsets.</p>

          <p>Prior to Wonder, Alex spent several years running an innovation studio in London working with FTSE 100 companies and startups from seed to series C. He experienced first-hand the difficulties innovators face when bringing their products to life. In late 2016, he set on a mission to change that and make it easier to innovate and bring inventions to market by building a platform that became Wonder.</p> -->

        </div>
      </div>
    </div>
    <hr class="divider">
    <div class="container">
      <div class="row">
        <div class="col">

          <h1 class="title">Clients</h1>

          <p>Alex has delivered products for:</p>

          <div class="row clients">
            <div class="col col-sm-2 col-3 p-4">
              <img class="img-fluid" src="/static/images/clients/accenture.png">
            </div>
            <div class="col col-sm-2 col-3 p-4">
              <img class="img-fluid" src="/static/images/clients/barclays.png">
            </div>
            <div class="col col-sm-2 col-3 p-4">
              <img class="img-fluid" src="/static/images/clients/british_museum.png">
            </div>
            <div class="col col-sm-2 col-3 p-4">
              <img class="img-fluid" src="/static/images/clients/clarins.png">
            </div>
            <div class="col col-sm-2 col-3 p-4">
              <img class="img-fluid" src="/static/images/clients/google.png">
            </div>
            <div class="col col-sm-2 col-3 p-4">
              <img class="img-fluid" src="/static/images/clients/nhs.png">
            </div>
            <div class="col col-sm-2 col-3 p-4">
              <img class="img-fluid" src="/static/images/clients/natwest.png">
            </div>
            <div class="col col-sm-2 col-3 p-4">
              <img class="img-fluid" src="/static/images/clients/unilever.png">
            </div>
          </div>

          <hr class="space space-sm">
        </div>
      </div>
    </div>
    <hr class="divider">

    <div class="container" v-if="projects && projects.length">
      <div class="row">
        <div class="col">
          <h1 class="title">Recent work</h1>

          <hr class="space space-sm">
  
          <div v-for="project in projects" :key="project.id">
            <div class="row align-items-center cursor-pointer" @click="openProject(project.id)">
              <div class="col-md-8" v-if="project.picture">
                <img class="img-fluid img-card mb-3" :src="project.picture" alt="">
              </div>
              <div class="col-md-4 pr-md-5">
                <h2>{{ project.name }}</h2>
                <div v-html="project.tagline" class="lh15"></div>
                <p class="py-4">
                  <a href="#" @click.prevent="openProject(project.id)" class="btn btn-sm btn-outline-primary">Learn more</a>
                </p>
              </div>
            </div>
            <hr class="space d-none d-md-block">
            <hr class="space space-sm">
          </div>

        </div>
      </div>
      <hr class="divider">
    </div>

    <div class="container">
      <div class="row">
        <div class="col">

          <h1 class="title">Contact</h1>

          <p>You can contact Alex by email:</p>

          <p>
            <a href="mailto:alex@resolute.partners">alex@resolute.partners</a>
          </p>

          <hr class="space space-sm">

          <router-link :to="{ name: 'home' }">&larr; Back to Home</router-link>

          <hr class="space space-sm">

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import slugify from 'slugify'

export default {
  data () {
    return {
    }
  },
  computed: {
    ...mapState({
      projects: state => state.projects.portfolioProjects
    })
  },
  mounted () {
    window.scrollTo(0, 0)
    this.$store.dispatch('LOAD_PORTFOLIO_PROJECTS', 1)
  },
  methods: {
    openProject (id) {
      let project = this.projects.find((e) => e.id === id)
      if (project) {
        window.open(this.getProjectUrl(project))
      }
    },
    getProjectUrl (project) {
      if (project.case_study_url) {
        return project.case_study_url
      } else {
        return '/portfolio/' + project.id + '/' + slugify(project.name)
      }
    }
  }
}
</script>
